import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorPageComponent } from '../../error/error-page.component';

@Component({
  selector: 'app-unauthorised',
  templateUrl: '../../error/error-page.component.html',
  styleUrls: ['../../error/error-page.component.scss'],
  standalone: false
})
export class UnauthorisedComponent extends ErrorPageComponent {
  constructor(
    router: Router,
    route: ActivatedRoute) {
    super(router, route);

    this.errorTitle = 'Unauthorized';
  }
}
